<template>
  <div class="opcoes-fiscais">
    <div class="opcoes-fiscais-info">
      <i
        class="fa-regular fa-magnifying-glass"
        @click="openOptionsModal"
      ></i>
    </div>

    <Modal
      :title="modalTitle"
      :width="900"
      v-if="showModal(resolvedModalName)"
      :onHideModal="closeModal"
    >
      <div>
        <Alert type="info">
          <span>
            Estas são apenas sugestões, algumas opções podem não estar incluídas e podem ser adicionadas
            manualmente. Em caso de dúvida, consulte seu contador.
          </span>
        </Alert>

        <div class="opcoes-fiscais-search-wrapper">
          <input
            class="form-control opcoes-fiscais-search"
            type="text"
            v-model="searchTerm"
            placeholder="Pesquisar"
          />
        </div>

        <div class="opcoes-fiscais-list mt-2">
          <button
            v-for="(option, index) in filteredOptions"
            :key="`${index}-${option.id || option.content}`"
            type="button"
            class="opcoes-fiscais-item"
            @click="selectOption(option)"
          >
            {{ option.content || option.id }}
          </button>

          <div
            v-if="!filteredOptions.length"
            class="text-center p-2"
          >
            Nenhuma opção encontrada.
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "OpcoesFiscaisGoverno",
  components: {
    Modal,
    Alert,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    buttonTitle: {
      type: String,
      default: "Ver opções",
    },
    modalTitle: {
      type: String,
      default: "Opções Fiscais Governo",
    },
    modalName: {
      type: String,
      default: "OpcoesFiscaisGoverno",
    },
    onlyNumber: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchTerm: "",
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal"]),
    resolvedModalName() {
      return `${this.modalName}-${this._uid}`;
    },
    filteredOptions() {
      const rawTerm = String(this.searchTerm || "")
        .trim()
        .toLowerCase();
      const normalizedTerm = this.normalizeForSearch(rawTerm);
      if (!rawTerm) return this.options;

      return this.options.filter((option) => {
        const contentRaw = String(option.content || "").toLowerCase();
        const idRaw = String(option.id || "").toLowerCase();
        const content = this.normalizeForSearch(contentRaw);
        const id = this.normalizeForSearch(idRaw);

        return (
          contentRaw.includes(rawTerm) ||
          idRaw.includes(rawTerm) ||
          this.matchSearchTerm(content, normalizedTerm) ||
          this.matchSearchTerm(id, normalizedTerm)
        );
      });
    },
  },
  methods: {
    ...mapMutations("generic", ["openModal", "hideModal"]),
    ...mapMutations("validation", ["updateFormDirty"]),
    normalizeForSearch(value) {
      return String(value || "")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
    },
    matchSearchTerm(value, term) {
      if (!value || !term) return false;
      if (value.includes(term)) return true;

      let termIndex = 0;
      for (
        let index = 0;
        index < value.length && termIndex < term.length;
        index++
      ) {
        if (value[index] === term[termIndex]) {
          termIndex += 1;
        }
      }

      return termIndex === term.length;
    },
    openOptionsModal() {
      this.openModal(this.resolvedModalName);
      this.$nextTick(() => {
        const backdrops = document.querySelectorAll(".modal-backdrop");
        const backdrop = backdrops[backdrops.length - 1];

        if (backdrop) {
          backdrop.style.backgroundColor = "transparent";
          backdrop.style.opacity = "0";
        }
      });
    },
    closeModal() {
      this.searchTerm = "";
      this.hideModal(this.resolvedModalName);
    },
    selectOption(option) {
      const selectedValue = String(option.id || option.content || "");
      const formattedValue = this.onlyNumber
        ? selectedValue.split("-")[0].trim()
        : selectedValue;

      this.$emit("input", formattedValue);
      this.closeModal();

      setTimeout(() => {
        this.updateFormDirty(true);
      }, 0);
    },
  },
};
</script>

<style scoped>
.opcoes-fiscais {
  display: flex;
  align-items: center;
  height: 100%;
}

.opcoes-fiscais-list {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.opcoes-fiscais-search-wrapper {
  margin-bottom: 8px;
}

.opcoes-fiscais-search {
  border-radius: 999px !important;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  padding-left: 16px;
  padding-right: 16px;
  min-height: 42px;
  font-size: 14px;
}

.opcoes-fiscais-search:focus {
  border-color: #60a5fa;
  box-shadow: 0 0 0 0.2rem rgba(96, 165, 250, 0.2);
}

.opcoes-fiscais-item {
  width: 100%;
  text-align: left;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #dee2e6;
  padding: 8px 10px;
}

.opcoes-fiscais-item:last-child {
  border-bottom: 0;
}

.opcoes-fiscais-info {
  font-size: 23px;
  margin-left: -6px;
  cursor: pointer;
  color: rgb(73, 73, 73);
}
</style>
